import { RightOutlined } from "@ant-design/icons";
import { List, Typography } from "antd";
import React from "react";

const Applications = ({ product }) => {
  return (
    <div style={{ margin: "24px 0" }}>
      <Typography.Title
        level={3}
        className="applications-title"
        style={{ marginBottom: "16px", textAlign: "center" }}
      >
        Applications
      </Typography.Title>
      <List
        itemLayout="horizontal"
        dataSource={product?.product_application}
        renderItem={(item) => (
          <List.Item style={{ alignItems: "center" }}>
            <List.Item.Meta
              avatar={
                <div
                  style={{
                    marginRight: "12px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <RightOutlined
                    style={{
                      color: "#1890ff",
                      fontSize: "14px",
                    }}
                  />
                  <RightOutlined
                    style={{
                      color: "#87CEEB",
                      fontSize: "14px",
                      marginLeft: "-9px",
                    }}
                  />
                </div>
              }
              title={
                <Typography.Text strong className="application-heading">
                  {item.heading}
                </Typography.Text>
              }
              description={
                <span className="application-description">
                  {item.application}
                </span>
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
};

export default Applications;
